import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { Close } from "@mui/icons-material";
import { FileType } from "../models/form.model";
import { openWindowInAsync } from "../actions/common.action";
import api from "../lib/api";

export interface PreviewDialogProps {
  title?: string;
  src?: string | any;
  type: FileType;
  open: boolean;
  maxWidth?: number;
}

export default function PreviewMediaDialog() {
  const [dialog, setDialog] = React.useState<PreviewDialogProps>({
    title: "Preview",
    type: FileType.image,
    open: false,
  });

  const onCancel = async () => {
    setDialog({ ...dialog, open: false });
  };

  React.useEffect(() => {
    window.webApp = window.webApp || {};
    window.webApp.previewDialog = (param) => {
      if (param.type === FileType.pdf) {
        openWindowInAsync(async () => {
          const link = (
            await api<{ link: string }>({
              url: `/documents/${encodeURIComponent(param.src)}/link`,
              method: "GET",
            })
          ).link;
          return link;
        }, "PDF is loading...");
      } else {
        setDialog({ ...dialog, ...param });
      }
    };
  }, []);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog fullScreen={fullScreen} maxWidth={false} open={dialog.open}>
      <DialogTitle>
        {dialog.title}
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="justify-center-wrapper"
        sx={{
          minWidth: fullScreen ? "initial" : "840px",
          maxWidth: dialog.maxWidth,
          minHeight: "480px",
        }}
      >
        {dialog.type === FileType.image && <img alt="url" style={{ maxWidth: "100%" }} src={dialog.src} />}
        {dialog.type === FileType.avatar && <img alt="url" style={{ width: 320 }} src={dialog.src} />}
        {dialog.type === FileType.text && (
          <div className="width-100p" style={{ wordBreak: "break-all" }}>
            {dialog.src}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
